import React from 'react'

import { AppGrowingContainer } from 'components/Common/AppGrowingContainer/AppGrowingContainer.component'
import { AppCashBalanceByMonthTestChart } from 'components/AppDataReport/AppData/AppOverview/AppCashBalanceByMonth/AppCashBalanceByMonthChart.component'
import { AppCashBalanceChart } from 'components/AppDataReport/AppData/AppOverview/AppCashBalance/AppCashBalanceChartData.component'

export const AppAccountingOverview = () => {
  return (
    <AppGrowingContainer>
      <div className="grid col-span-12 p-7">
        <div className="grid grid-cols-10 gap-4">
          <div className="col-span-10 smd:col-span-4 bg-white">
            <AppCashBalanceChart />
          </div>
          <div className="col-span-10 smd:col-span-6 bg-white">
            <AppCashBalanceByMonthTestChart />
          </div>
        </div>
      </div>
    </AppGrowingContainer>
  )
}
